export enum CompatibilityFailure {
  SafariOutdated = 'safariOutdated',
  DeviceUnsupported = 'deviceUnsupported',
  BrowserOutdated = 'browserOutdated',
  BrowserUnsupported = 'browserUnsupported',
}
